export default __webpack_public_path__ + "static/media/icon-download-gray.a6ad373d.svg";